export const courseApplicationReferralSources = [
  'Google search',
  'LinkedIn',
  'Facebook',
  'Instagram',
  'INSOL website',
  'Email newsletter',
  'Colleague or friend',
  'Professional association',
  'Event or webinar',
  'Other'
];

export const asksForReferralSource = (course) =>
  /\b(?:SARIPA|RISA)\b/i.test(`${course?.courseTitle || ''} ${course?.courseSummary || ''}`);
